/* eslint-disable global-require */
module.exports = {
  header: require('./header'),
  splash: require('./splash'),
  storesLocation: require('./storesLocation'),
  shared: require('./shared'),
};
